import React from 'react';
import { ArchiveCatalog } from '../components/archive20260728/ArchiveCatalog';
import { ArchiveFooter } from '../components/archive20260728/ArchiveFooter';
import { ArchiveHeader } from '../components/archive20260728/ArchiveHeader';
import { ArchiveHero } from '../components/archive20260728/ArchiveHero';
import { ArchiveIntro } from '../components/archive20260728/ArchiveIntro';
import { ArchiveSupport } from '../components/archive20260728/ArchiveSupport';
export function ArchiveHome20260728() {
  return <div className="flex min-h-screen w-full max-w-full flex-col overflow-x-hidden bg-white" data-id="element-805" data-mp="2z1na3cnomlet">
      <div className="relative box-border w-full max-w-full overflow-hidden border-b border-slate-200 bg-slate-100 py-1.5 text-slate-600" data-id="element-806" data-mp="3dq1jk6flt84c">
        <div className="mx-auto w-full max-w-full box-border whitespace-normal break-words px-3 pr-32 text-center text-[12px] font-medium leading-tight sm:px-4 sm:pr-4 sm:text-xs xl:text-[13px]" data-id="element-807" data-mp="38xqjn3kv5mbs">
          <span className="block sm:inline" data-id="element-808" data-mp="2ga45j1e0ezao">
            Medical modality equipment, training &amp; support
          </span>
          <span className="hidden sm:inline" data-id="element-809" data-mp="1kuxeq7e2q22g"> </span>
          <span className="block sm:inline" data-id="element-810" data-mp="1pujv2pp77yfh">
            for chiropractic, rehab &amp; wellness practices.
          </span>
        </div>
        <a href="/" target="_blank" rel="noopener noreferrer" className="absolute right-3 top-1/2 -translate-y-1/2 whitespace-nowrap text-[10px] font-medium text-slate-600 transition-colors hover:text-navy hover:underline sm:right-4 sm:text-xs" data-id="element-811" data-mp="1uoo033ewlwdx">
          See current version
        </a>
      </div>
      <ArchiveHeader data-id="element-812" data-mp="1ayaunktknf1h" />
      <main className="flex-1" data-id="element-813" data-mp="1ax0wkvmpy6uu">
        <ArchiveHero data-id="element-814" data-mp="1b0x3row422lt" />
        <ArchiveIntro data-id="element-815" data-mp="1fy6q2vo7dy5f" />
        <ArchiveCatalog data-id="element-816" data-mp="1fyq78a614iie" />
        <ArchiveSupport data-id="element-817" data-mp="1fyym27lppxw8" />
      </main>
      <ArchiveFooter data-id="element-818" data-mp="2mdzkql24gu6i" />
    </div>;
}